import Disclaimer from './components/Disclaimer.jsx';
import MyStack from './components/MyStack.jsx';
import DcaSimulator from './components/DcaSimulator.jsx';
import StreakTracker from './components/StreakTracker.jsx';
import Goals from './components/Goals.jsx';
import OnchainRank from './components/OnchainRank.jsx';
import Settings from './components/Settings.jsx';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-stone-800/60 bg-stone-950/40 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-orange-500 to-amber-400 flex items-center justify-center text-lg">
              🔥
            </div>
            <div>
              <div className="font-display font-bold text-lg leading-none">BMore Wealthy Stack</div>
              <div className="text-xs text-stone-500 mt-0.5">Stack sats. Build the habit.</div>
            </div>
          </div>
          <div className="text-xs font-mono text-stone-500 hidden sm:block">v0.7 · MVP</div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl mx-auto w-full px-6 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          <MyStack />
          <Goals />
          <StreakTracker />
          <DcaSimulator />
          <OnchainRank />
          <Settings />
        </div>
      </main>

      <Disclaimer />
    </div>
  );
}
